(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["installation-guide"] && !Shopify.designMode) return;
  try {
    
  window.installationGuide = function (options) {
    const opts = options || {};
    return {
      activeId: opts.initial || '',
      setActive(id) {
        if (this.activeId === id) return;
        this.activeId = id;
        this.$root.querySelectorAll('video').forEach((video) => {
          if (video.dataset.blockId !== id && !video.paused) {
            video.pause();
          }
        });
        this.$nextTick(() => this.moveIndicator());
      },
      moveIndicator() {
        const tabs = this.$refs.tabs;
        const indicator = this.$refs.indicator;
        if (!tabs || !indicator) return;
        const active = tabs.querySelector(`[data-tab-id="${this.activeId}"]`);
        if (!active) return;
        indicator.style.width = `${active.offsetWidth}px`;
        indicator.style.height = `${active.offsetHeight}px`;
        indicator.style.transform = `translate(${active.offsetLeft}px, ${active.offsetTop}px)`;
      },
    };
  };

  window.addEventListener('resize', () => {
    document.querySelectorAll('.installation-guide__tabs').forEach((tabs) => {
      const root = tabs.closest('[x-data]');
      if (root && root._x_dataStack && root._x_dataStack[0].moveIndicator) {
        root._x_dataStack[0].moveIndicator();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  document.addEventListener('alpine:init', () => {
    Alpine.data('blogFilter', (sectionId) => ({
      async filterByTag(el) {
        const tagUrl = el.getAttribute('href');

        const allLinks = this.$root.querySelectorAll('.blog-tag-btn');
        for (const link of allLinks) {
          link.classList.remove('is-active');
          link.removeAttribute('aria-current');
        }
        el.classList.add('is-active');
        el.setAttribute('aria-current', 'page');

        const articlesContainer = document.getElementById(`BlogArticles-${sectionId}`);
        articlesContainer.classList.add('is-loading');

        try {
          const response = await fetch(`${tagUrl}?sections=${sectionId}`);
          if (!response.ok) throw new Error(`HTTP ${response.status}`);

          const data = await response.json();
          const parser = new DOMParser();
          const doc = parser.parseFromString(data[sectionId], 'text/html');

          const newArticles = doc.getElementById(`BlogArticles-${sectionId}`);
          if (newArticles && articlesContainer) {
            articlesContainer.replaceWith(newArticles);
          }

          const paginationContainer = document.getElementById(`BlogPagination-${sectionId}`);
          const newPagination = doc.getElementById(`BlogPagination-${sectionId}`);
          if (paginationContainer && newPagination) {
            paginationContainer.replaceWith(newPagination);
          } else if (paginationContainer && !newPagination) {
            paginationContainer.remove();
          } else if (!paginationContainer && newPagination) {
            this.$root.appendChild(newPagination);
          }

          history.pushState({}, '', tagUrl);
        } catch (error) {
          console.error('Blog filter error:', error);
          window.location.href = tagUrl;
        }
      },

      init() {
        window.addEventListener('popstate', () => window.location.reload());
      }
    }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-navbar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('alpine:init', () => {
    Alpine.data('stickyNavbar', () => ({
      open: false,
      isSticky: false,
      isDark: false,
      stickyOffset: 0,
      observer: null,
      calculateOffset() {
        const heroSection = document.querySelector('.hero');
        this.stickyOffset = heroSection ? heroSection.offsetTop + heroSection.offsetHeight : window.innerHeight;
      },
      updateSticky() {
        const scrollPosition = window.scrollY || document.documentElement.scrollTop;
        this.isSticky = scrollPosition >= this.stickyOffset;
        const header = document.querySelector('.section-header');
        if (header) {
          header.classList.toggle('header-hidden-for-sticky', this.isSticky);
        }
      },
      checkDarkSection() {
        const navbar = this.$el;
        const navbarRect = navbar.getBoundingClientRect();
        const navbarMiddle = navbarRect.top + navbarRect.height / 2;

        // Find all sections with data-theme="dark"
        const darkSections = document.querySelectorAll('[data-theme="dark"]');
        let isOverDark = false;

        darkSections.forEach((section) => {
          const sectionRect = section.getBoundingClientRect();
          // Check if navbar middle point is within this dark section
          if (navbarMiddle >= sectionRect.top && navbarMiddle <= sectionRect.bottom) {
            // Check if this section has a gradient transition
            const gradientPosition = section.getAttribute('data-gradient-position');
            if (gradientPosition) {
              // Calculate the pixel position where gradient transitions from dark to light
              const gradientPercent = parseFloat(gradientPosition) / 100;
              const gradientTransitionY = sectionRect.top + sectionRect.height * gradientPercent;
              // Only consider dark if navbar is above the gradient transition point
              if (navbarMiddle < gradientTransitionY) {
                isOverDark = true;
              }
              // If navbar is below gradient transition, it's over the light part
            } else {
              // No gradient, entire section is dark
              isOverDark = true;
            }
          }
        });

        this.isDark = isOverDark;
      },
      init() {
        this.$nextTick(() => {
          this.calculateOffset();
          this.updateSticky();
          this.checkDarkSection();
        });
      },
    }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tb-city-product"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-city-gallery-step]');
    if (!button) return;
    const gallery = button.closest('tb-ev-gallery');
    if (typeof gallery?.go === 'function') {
      gallery.go(gallery.index + Number(button.dataset.cityGalleryStep));
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tb-family-product"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-family-gallery-step]');
    if (!button) return;
    const gallery = button.closest('tb-ev-gallery');
    if (typeof gallery?.go === 'function') {
      gallery.go(gallery.index + Number(button.dataset.familyGalleryStep));
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tb-master-product"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-city-gallery-step]');
    if (!button) return;
    const gallery = button.closest('tb-ev-gallery');
    if (typeof gallery?.go === 'function') {
      gallery.go(gallery.index + Number(button.dataset.cityGalleryStep));
    }
  });

  } catch(e) { console.error(e); }
})();
})();
